(function () {
    function locationBanner() {

        loadGoogleMaps();

        var mapNode = document.querySelector('#map'),
            mapModel,
            markerPin = {
                scale: 7,
                fillColor: '#0077c8',
                fillOpacity: 0.9,
                strokeWeight: 0
            };

        function initMap() {

            const center = {
                lat: parseFloat(mapNode.dataset.lat),
                lng: parseFloat(mapNode.dataset.lng),
            };

            mapModel = new google.maps.Map(mapNode, {
                zoom: mapNode.dataset.zoom ? parseFloat(mapNode.dataset.zoom, 10) : 14,
                center,
                styles: getStyles(),
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControl: false,
            });

            markerPin.path = google.maps.SymbolPath.BACKWARD_CLOSED_ARROW;

            var marker = new google.maps.Marker({
                map: mapModel,
                position: center,
                icon: markerPin
            });
        };

        //get google maps if it doesn't exist
        function loadGoogleMaps() {
            $.ajax({
                url: '//www.google.com/jsapi',
                dataType: 'script',
                cache: true,
                success: function () {
                    google.load('maps', '3', {
                        other_params: 'key=AIzaSyDgXfI4_9CByI-_bS_CApP1xwk5WzScEqs',
                        callback: initMap
                    });
                }
            });
        };

        function getStyles() {
            return [
                {
                    "featureType": 'all',
                    "elementType": 'labels',
                    "stylers": [
                        {
                            "visibility": 'off'
                        }
                    ]
                },
                {
                    "featureType": 'landscape',
                    "elementType": 'all',
                    "stylers": [
                        {
                            "hue": '#FFBB00'
                        },
                        {
                            "saturation": 43.400000000000006
                        },
                        {
                            "lightness": 37.599999999999994
                        },
                        {
                            "gamma": 1
                        }
                    ]
                },
                {
                    "featureType": 'poi',
                    "elementType": 'all',
                    "stylers": [
                        {
                            "hue": '#00FF6A'
                        },
                        {
                            "saturation": -1.0989010989011234
                        },
                        {
                            "lightness": 11.200000000000017
                        },
                        {
                            "gamma": 1
                        }
                    ]
                },
                {
                    "featureType": 'road',
                    "elementType": 'labels',
                    "stylers": [
                        {
                            "visibility": 'on'
                        }
                    ]
                },
                {
                    "featureType": 'road.highway',
                    "elementType": 'all',
                    "stylers": [
                        {
                            "hue": '#FFC200'
                        },
                        {
                            "saturation": -61.8
                        },
                        {
                            "lightness": 45.599999999999994
                        },
                        {
                            "gamma": 1
                        }
                    ]
                },
                {
                    "featureType": 'road.arterial',
                    "elementType": 'all',
                    "stylers": [
                        {
                            "hue": '#FF0300'
                        },
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 51.19999999999999
                        },
                        {
                            "gamma": 1
                        }
                    ]
                },
                {
                    "featureType": 'road.local',
                    "elementType": 'all',
                    "stylers": [
                        {
                            "hue": '#FF0300'
                        },
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 52
                        },
                        {
                            "gamma": 1
                        }
                    ]
                },
                {
                    "featureType": 'water',
                    "elementType": 'all',
                    "stylers": [
                        {
                            "hue": '#0078FF'
                        },
                        {
                            "saturation": -13.200000000000003
                        },
                        {
                            "lightness": 2.4000000000000057
                        },
                        {
                            "gamma": 1
                        }
                    ]
                },
                {
                    "featureType": 'administrative',
                    "elementType": 'labels',
                    "stylers": [
                        {
                            "visibility": 'on'
                        }
                    ]
                }
            ];
        }
    }

    angular.module('Uscapp').controller('Usc.LocationBanner.Ctrl', [locationBanner]);
}());